module.exports = __webpack_public_path__ + "static/img/complex_good_slur.523ab0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oneMachine/complex_good_slur.png
// module id = 8duh
// module chunks = 0